import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { SubscribeUnSubscribeFlashMessageRequest } from './subscribeunsubscribeflashmessagesrequest';

export class SubscribeUnSubscribeFlashMessageAPI extends SixdeeCRBTAPI<SubscribeUnSubscribeFlashMessageRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    { 
        return "flash/subscriber-management/subscribers/delete-subscription";
    }

    protected getRequestData() {
        return {
            "msisdn": this.getRequest().getMsisdn(),
            "channelId":"1"
        };
    }

    getBASEURL(): string
    {
        return this.getContext().getProperty().getFlashURL() + 
            this.getAPIURL();
    }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/subscribeunsubscribe/subscribeunsubscribeflashmessagesapi.tsx